import clsx from 'clsx';
import React from 'react';

const EditorString = ({ value, className = '' }) => {
  return value ? (
    <div
      className={clsx('editor-string', className)}
      dangerouslySetInnerHTML={{ __html: value }}
    ></div>
  ) : null;
};

export default EditorString;
